import React from 'react'
import {
  colorFamilies,
  colorFamilyLabels,
  colorShades,
  dsColorVar,
  getDesignSystemColor,
} from '@enamelai/design-system'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import './ColorPaletteShowcase.css'

const ColorPaletteShowcase: React.FC = () => {
  return (
    <UiPreviewCanvas
      title="Color palette"
      description="Core color families and shades used across components, sourced from design tokens."
      stageClassName="ui-preview__stage--wide color-palette-showcase__stage-wrap"
    >
      <div className="color-palette-showcase__sheet">
        {colorFamilies.map((family) => (
          <section key={family} className="color-palette-showcase__family">
            <h3 className="color-palette-showcase__family-title">
              {colorFamilyLabels[family]}
            </h3>
            <div className="color-palette-showcase__row">
              {colorShades.map((shade) => {
                const tokenName = `--ds-${family}-${shade}`
                const hex = getDesignSystemColor(family, shade)

                return (
                  <div
                    key={shade}
                    className="color-palette-showcase__swatch"
                    style={{ backgroundColor: dsColorVar(family, shade) }}
                  >
                    <span
                      className={`color-palette-showcase__swatch-label${
                        shade >= 400
                          ? ' color-palette-showcase__swatch-label--on-dark'
                          : ''
                      }`}
                    >
                      {shade}
                    </span>
                    <div className="color-palette-showcase__swatch-hover">
                      <span className="color-palette-showcase__swatch-token">
                        {tokenName}
                      </span>
                      <span className="color-palette-showcase__swatch-var">
                        {dsColorVar(family, shade)}
                      </span>
                      <span className="color-palette-showcase__swatch-hex">
                        {hex}
                      </span>
                    </div>
                  </div>
                )
              })}
            </div>
          </section>
        ))}
      </div>
    </UiPreviewCanvas>
  )
}

export default ColorPaletteShowcase
